import { styled } from 'baseui'

export const StyledContainer = styled('div', () => ({
  width: '100%',
  padding: '0rem',
}))

export const StyledTopContainer = styled('div', () => ({
  width: '100%',
  padding: '1rem 1rem 0rem 1rem',
}))

export const StyledHeader = styled('div', () => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '1rem',
}))

export const StyledTitle = styled('h3', () => ({
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  fontWeight: '600',
  fontSize: '1.125rem',
  lineHeight: '160%',
  color: '#343535',
}))

export const UpdatedAt = styled('div', {
  fontSize: '0.75rem',
  color: '#555',
  marginBottom: '0.5rem',
})

export const GrayBlock = styled('div', {
  width: '100%',
})

export const GrayBlockContent = styled('div', {
  backgroundColor: '#ffffff',
  borderRadius: '0.375rem',
  padding: '0.55rem',
  color: '#333',
  lineHeight: 1.4,
})

export const OuterCard = styled('div', {
  backgroundColor: '#f3f8fc',
  padding: '1rem',
  marginBottom: '10px',
  fontSize: '0.875rem',
})

export const Header = styled('div', {
  fontWeight: 600,
  color: '#204b78',
  display: 'flex',
  alignItems: 'center',
  fontSize: '1rem',
})

export const StyledEmptyState = styled('div', {
  fontStyle: 'italic',
  color: '#888',
  textAlign: 'center',
  margin: '2rem 0',
})
